import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { selectTag, selectRoomType } from 'actions/querysettings';
import config from 'config';

import RoomTypeSelector from 'components/common/dropdowncomponents/roomtypeselector';
import TagSelector from 'components/common/dropdowncomponents/tagselector';
import StatsExport from 'components/common/dropdowncomponents/dataexportdropdown/statsexport';
import StatsMenu from "components/common/statsmenu"
// This component is used in components/pages/stats/index.jsx
export class CustomStatsMenu extends React.Component {
    constructor(props) {
        super(props);
        var cntTypes = this.countTypes(props.node);

        this.state = {
            typeCount: cntTypes
        }
    }

    chooseTag(tag) {
        this.props.dispatch(selectTag(tag));
    }

    chooseType(type) {
        this.props.dispatch(selectRoomType(type));
        if (type.code == "open_area" || type.code == "all_areas") {
            this.chooseTag(config.tag.OCCUPANCY.type);
        }
    }

    componentWillReceiveProps(nextProps) {
        var typeCount = this.countTypes(nextProps.node);
        this.setState({ typeCount: typeCount });

        if (typeCount.cntOA > 0 && typeCount.cntMR == 0) { // only OA
            if (nextProps.room.code != 'open_area') {
                nextProps.dispatch(selectRoomType(config.room.OPENAREA));
            }
            if (nextProps.tag == 'Efficiency') {
                nextProps.dispatch(selectTag('Occupancy'));
            }
        } else if (typeCount.cntOA == 0 && typeCount.cntMR > 0) { // only MR
            if (nextProps.room.code != 'meeting_room') {
                nextProps.dispatch(selectRoomType(config.room.MEETINGROOM));
            }
        }
    }

    render() {
        // for room type selector. If a location node has only MRs then only "Meeting rooms" is selected. So the same for OA.
        var type = this.props.node.type;
        if (this.state.typeCount.cntOA > 0 && this.state.typeCount.cntMR == 0) {
            type = "open_area";
        } else if (this.state.typeCount.cntMR > 0 && this.state.typeCount.cntOA == 0) {
            type = "meeting_room";
        }
        let statsClass = "stats-menu__list-item  stats-menu__select";
        let statsClassClickable = statsClass + " cursor--pointer";
        return (
            <React.Fragment>
                <StatsMenu
                    leftItemBold={this.props.name}
                    leftItems={
                        <React.Fragment>
                            <span className={type === "location" ? statsClassClickable : statsClass} >
                                <RoomTypeSelector roomType={type} chooseType={this.chooseType.bind(this)} type={this.props.room.type} />
                            </span>
                            <span className={this.props.room.code === "meeting_room" ? statsClassClickable : statsClass} >
                                <TagSelector roomType={this.props.room.code} chooseTag={this.chooseTag.bind(this)} tag={this.props.tag} />
                            </span>
                            <span className="cursor--pointer stats-menu__list-item ">
                                <StatsExport node={this.props.node} />
                            </span>
                        </React.Fragment>
                    }
                    rightItems={
                        <React.Fragment>
                            <Link className="stats-menu__list-item stats-menu__list-item_link" to={this.props.node.info.hasfloorplan ? `heatmap/${this.props.id}` : null} >
                                <span className="font-icon icon-heatmap" />
                                <span className="text" >Heatmap</span>
                            </Link>
                            <Link className="stats-menu__list-item stats-menu__list-item_link" to={this.props.node.info.hasfloorplan ? `live/${this.props.id}` : null} >
                                <span className="font-icon icon-live" />
                                <span className="text">Live</span>
                            </Link>
                        </React.Fragment>
                    }
                />
            </React.Fragment>

        );
    }

    countTypes(node) {
        var self = this;
        var res = {
            cntMR: (node.type == "meeting_room" ? 1 : 0),
            cntOA: (node.type == "open_area" ? 1 : 0)
        }
        if (node.children) {
            node.children.map((child) => {
                if (child.type != "sensor") {
                    let resChild = self.countTypes(child);
                    res.cntMR += resChild.cntMR;
                    res.cntOA += resChild.cntOA;
                }
            });
        }
        return res
    }
}

function mapStateToProps(state) {
    return {
        tag: state.querySettingsReducer.tag,
        room: state.querySettingsReducer.room
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomStatsMenu);



// WEBPACK FOOTER //
// ./src/components/pages/stats/customstatsmenu.jsx